import React, { useState } from "react";
import { supabase } from "../supabaseClient";
import { Link } from "react-router-dom";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: window.location.origin + "/reset-password",
    });

    if (error) setError(error.message);
    else setMessage("Password reset email sent! Check your inbox.");
  };

  return (
    <div className="min-h-screen bg-bg text-text-primary flex items-center justify-center p-6">
      <div className="w-full max-w-lg bg-white border border-border p-10 rounded-2xl shadow-sm">

        <h1 className="text-3xl font-bold mb-6 text-text-primary">Forgot Password?</h1>
        <p className="text-text-secondary mb-8">Enter your email to receive reset instructions.</p>

        <form onSubmit={handleForgotPassword} className="space-y-5">
          <div>
            <label className="block text-text-primary mb-2 text-sm">Email Address</label>
            <input
              type="email"
              className="w-full px-4 py-3 rounded-md bg-bg-soft border border-border text-text-primary placeholder:text-text-muted focus:outline-none focus:ring-2 focus:ring-accent transition"
              placeholder="your@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          {error && <p className="text-red-500 text-sm">{error}</p>}
          {message && <p className="text-green-600 text-sm">{message}</p>}

          <button
            type="submit"
            className="w-full bg-primary text-white font-bold py-3 rounded-md hover:bg-primary-soft transition"
          >
            Send Reset Email
          </button>
        </form>

        <p className="text-center text-text-secondary mt-8 text-sm">
          Back To{" "}
          <Link to="/login" className="text-text-primary font-semibold hover:text-accent hover:underline transition">
            Login
          </Link>
        </p>
      </div>
    </div>
  );
}